import configuration from "./configuration";

export const isLoggedIn = (authContext): boolean => {
    return authContext?.isAuthenticated;
};

export const hasCognitoDatashopRole = (authContext): boolean => {
    const rolesUserHas = authContext?.user?.["cognito:groups"];
    if (isUsedCognito)
        return rolesUserHas?.includes(configuration.authRole);
    return false;
}

export const isUser = (authContext): boolean => {
    if (!isLoggedIn(authContext)) return false;
    if (isUsedCognito()) return hasCognitoDatashopRole(authContext);
    else if (isUsedOpenAM()) {
        const userRoles = getUserRoles(authContext)
        const allRoles = getAllRoles();
        return userRoles.some(userRole => allRoles.includes(userRole));
    }
    return false;
}

export const isPrivilegedUser = (authContext): boolean => {
    if (isUsedCognito()) return false;
    else if (isUsedOpenAM()) {
        const userRoles = getUserRoles(authContext)
        const privilegedRoles = getPrivilegedRoles();
        return userRoles.some(userRole => privilegedRoles.includes(userRole));
    }
    return false;
}

export const isUserType = (authContext, role): boolean => {
    if (isUsedCognito()) return false;
    else if (isUsedOpenAM()) {
        const userRoles = getUserRoles(authContext)
        return userRoles.includes(role);
    }
    return false;
}

export const isShopManagerUser = (authContext): boolean => {
    return isUserType(authContext, configuration.wdsShopManagerUser);
}

export const isAdminUser = (authContext): boolean => {
    return isUserType(authContext, configuration.wdsAdminUser);
}

export const isAnonymousRoute = (route): boolean => {
    return route.role === "anonymous" || route.role === undefined;
};

export const isUserRoute = (route): boolean => {
    return route.role === "user";
};

export const isAdminRoute = (route): boolean => {
    return route.role === "admin";
};

export const isAddressExist = address => {
    return address.name && address.addressLine1 && address.city && address.postcode && address.country;
};

export const getUserRoles = (authContext): string[] => {
    if (isUsedCognito()) return [];
    return authContext?.user?.[configuration.authGroup] || [];
}

export const getPrivilegedRoles = (): string[] => {
    return [configuration.wdsShopViewerUser, configuration.wdsShopManagerUser, configuration.wdsAdminUser, configuration.wdsEurexUser, configuration.wdsSalesUser];
}

export const getAllRoles = (): string[] => {
    return [configuration.wdsUser, ...getPrivilegedRoles()];
}

export const isUsedCognito = (): boolean => {
    return configuration.authProvider === "cognito";
}

export const isUsedOpenAM = (): boolean => {
    return configuration.authProvider === "openam";
}
